import { createStore, applyMiddleware } from 'redux'
import oauth2ImplicitGrant from '../authenticators/oauth2ImplicitGrant'
import oauth2PasswordGrant from '../authenticators/oauth2PasswordGrant'
import {
  createAuthMiddleware,
  getInitialAuthState,
  oauth2BearerAuthorizer,
  storage
} from 'redux-simple-auth'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'
import reducer from '../reducers'

const authMiddleware = createAuthMiddleware({
  authenticators: [oauth2ImplicitGrant, oauth2PasswordGrant],
  authorize: oauth2BearerAuthorizer,
  syncTabs: true,
  refresh: response => {
    const token = response.headers.get('x-access-token')

    return token ? { token } : null
  }
})

export default createStore(
  reducer,
  composeWithDevTools(
    applyMiddleware(authMiddleware),
    getInitialAuthState({ storage })
  )
)



// WEBPACK FOOTER //
// ./src/config/store.js